module.exports = __webpack_public_path__ + "static/18(4)-778afba47495c152d4a0860841c792bd.jpg";